import React, { useState } from 'react';
import { Tabs, Tab, Container } from 'react-bootstrap';
import QuotationListOne from './QuotationListOne';

const OrderTabsPage = () => {
  const [key, setKey] = useState('sublimation');

  return (
    <div className="order-tabs-page">
      <Container fluid className="p-0">
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          id="order-tabs"
          className="custom-tabs"
          justify
        >
          <Tab eventKey="sublimation" title="Sublimation Orders">
            <div className="tab-content-wrapper">
              <QuotationListOne quote_type={1}/>
            </div>
          </Tab>

          <Tab eventKey="product" title="Product Orders">
            <div className="tab-content-wrapper">
              <QuotationListOne quote_type={0}/>
            </div>
          </Tab>
        </Tabs>
      </Container>

      {/* Global Styles */}
      <style jsx global>{`
        .order-tabs-page {
          height: 100vh;
          overflow: hidden;
          background: #f0f2f5;
        }

        .custom-tabs .nav-item {
          margin: 0 6px;
        }

        .custom-tabs .nav-link {
          background: linear-gradient(to right, #e0e0e0, #f4f4f4);
          color: #444;
          border: none;
          border-radius: 12px 12px 0 0;
          padding: 10px 22px;
          font-weight: 500;
          transition: all 0.3s ease;
          box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.05);
        }

        .custom-tabs .nav-link:hover {
          background: linear-gradient(to right, #d6e0f0, #e8f0ff);
          color: #000;
          transform: scale(1.02);
        }

        .custom-tabs .nav-link.active {
          background: linear-gradient(135deg, #007bff, #00b4d8);
          color: white;
          font-weight: 600;
          box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.15);
          transform: scale(1.05);
        }

        .tab-content-wrapper {
          padding: 20px;
          overflow-y: auto;
          height: calc(100vh - 70px);
          background: #fff;
          border-radius: 0 12px 12px 12px;
          border: 1px solid #ddd;
          border-top: none;
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
        }
      `}</style>
    </div>
  );
};

export default OrderTabsPage;
